
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/about/done",
      function () {
        return require("private-next-pages/download/about/done/index.tsx");
      }
    ]);
  